var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ecs-tab-item",class:{ active: _vm.active },on:{"click":_vm.emitChange}},[_vm._t("default"),(_vm.count > 0)?_c('span',{staticClass:"badge badge-info badge-pill"},[_vm._v(" "+_vm._s(_vm.count)+" ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }